import styled from 'styled-components';

const Styled: any = {};

Styled.Avatar = styled.div`
   .avatar-cont {
      overflow: hidden;
      display:flex;
      justify-content: center;
      align-items: center;
      width: 30vw;
      height: 30vw; 
      max-width: 130px;
      max-height: 130px;
      border-radius: 100%;
      margin:auto;
      > img {
         width: 100%;
         height: 100%;
      }
    
   }

  @media(min-width: 600px) {
   .avatar-cont {
      margin: initial;
      width: 7vw;
      height: 7vw;
     }
  }
}

`;

export default Styled;
